(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-ui/product-header/assets/javascripts/product-header.js') >= 0) return;  svs.modules.push('/components/lb-ui/product-header/assets/javascripts/product-header.js');
"use strict";


const Brand = svs.ui.ReactBrand;
const ProductHeader = _ref => {
  let branding = _ref.branding,
    _ref$rightButton = _ref.rightButton,
    rightButton = _ref$rightButton === void 0 ? null : _ref$rightButton,
    _ref$leftButton = _ref.leftButton,
    leftButton = _ref$leftButton === void 0 ? null : _ref$leftButton,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 100 : _ref$size,
    _ref$rightBtnClass = _ref.rightBtnClass,
    rightBtnClass = _ref$rightBtnClass === void 0 ? '' : _ref$rightBtnClass;
  return React.createElement("div", {
    className: "product-header-react product-header-branding-".concat(branding)
  }, React.createElement("div", {
    className: "product-header-clip"
  }, React.createElement("div", null, leftButton && leftButton), React.createElement("div", null, React.createElement(Brand, {
    brand: branding,
    emblem: true,
    size: size
  })), React.createElement("div", {
    className: rightBtnClass
  }, rightButton && rightButton)));
};
setGlobal('svs.components.lbUi.productHeader.ProductHeader', ProductHeader);

 })(window);